/**
 * @Author: yxp
 * @Date:   2017-07-11 13:07:65
 * @Last modified by:   yxp
 * @Last modified time: 2017-09-12 11:09:26
 */

export const AREAS = [
  { name: '中国 +86', value: '+86', regex: /^1\d{10}$/ },
  { name: '中国台湾 +886', value: '+886', regex: /^09\d{8}$/ },
  { name: '美国 +1', value: '+1', regex: /^\d{10}$/ },
];

export default {
  common: {
    title: '青橙健身房管理系统',
    logo: 'http://img.qingchengfit.cn/771d7629d9a02c67378da5334ac6c30c.png',
    checkReq: '/api/user/check/',
    checkBindingReq: '/api/web/wechat/check/bind/',
    loginReq: '/api/user/login/',
    resetReq: '/api/staffs/reset/password/',
    registerReq: '/api/user/register/',
    bindReq: '/api/web/wechat/bind/',
    protocolReq: '/api/user/check/read_agreement/',
    next: '/backend/settings/',
  },
  fair: {
    title: '青橙专场招聘会管理系统',
    next: '/fair/admin/',
  },
  competition: {
    title: '青橙赛事训练营管理系统',
    next: '/competition/system/',
  },
  meeting: {
    title: '青橙会议/培训报名管理系统',
    checkReq: '/api/user/check/',
    loginReq: '/api/user/login/',
    next: 'http://meeting.qingchengfit.cn/settings',
  },
  clear: {
    title: '',
    checkReq: '/api/user/check/',
    loginReq: '/api/user/login/',
  },
};



// WEBPACK FOOTER //
// ./src/constants/login.js